export const SITE_DESC =
  "Klap turns long videos, podcasts and webinars into ready-to-post TikToks, Reels and YouTube Shorts in one click — with AI captions, smart reframing and viral-score insights.";
export const SITE_TITLE = "Turn videos into viral shorts";
export const REWARDFUL_LINK = "https://klap.getrewardful.com/signup";
export const REVIEW_USER_EMAILS = [
  "fbreview@klap.app",
  "ytreview@klap.app",
  "team+fbreview@klap.app",
];
